// ipad-pwa/src/lib/variant.js
// =============================================================================
// One Vite build serves TWO iPad apps from the same nginx vhost:
//   /        — production v1 (existing flow)
//   /v2/*    — testing v2 (adds CX Staff Card photo capture at sign-in)
//
// The variant is decided once at module load by inspecting the URL path.
// Everything downstream — storage namespace, screen routing, API calls —
// branches off this single constant.
// =============================================================================

function _detect() {
  if (typeof window === 'undefined') return false;
  return /^\/v2(\/|$)/.test(window.location.pathname);
}

export const IS_V2 = _detect();

// Different localStorage prefixes so a single iPad opened against /v1 and
// /v2 (same origin) doesn't collide pairings/sessions.
export const STORAGE_NS = IS_V2 ? 'iptbcv2.ipad.' : 'iptbc.ipad.';

// Pretty label used in screens that surface the variant (e.g. the
// PairingScreen header so the admin can tell which variant they're
// configuring).
export const VARIANT_LABEL = IS_V2 ? 'v2 (Staff Card photo)' : 'v1';
